import { Injectable } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { select, Store } from '@ngrx/store';
import { buildPrimaryKeyFilterExpression, FilterExpression } from 'src/app/filters/filter-definition';
import { FilterPrimitive } from 'src/app/filters/filter-primitives';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { EagerSelectActions } from './eager-select-actions';
import { EagerSelectSelectors } from './eager-select-selectors';
import { EagerSelectStatusService } from './eager-select-status.service';

@Injectable({ providedIn: 'root' })
export class NgrxEagerSelectService<TState extends object, TItem, TApiResponseItem = TItem> {
   constructor(private store: Store<TState>, private eagerSelectStatusService: EagerSelectStatusService) {}

   buildPrimaryKeyFilterExpression(
      primaryKey: keyof TItem & string,
      trigger: LcsSingleSelectDirective<TItem>
   ): FilterExpression | null;

   buildPrimaryKeyFilterExpression(
      primaryKey: keyof TApiResponseItem & string,
      trigger: LcsSingleSelectDirective<TItem>,
      getExistingPrimaryKey?: (item: TItem) => FilterPrimitive
   ): FilterExpression | null;

   buildPrimaryKeyFilterExpression(
      primaryKey: (keyof TApiResponseItem & string) | string,
      trigger: LcsSingleSelectDirective<any>,
      getExistingPrimaryKey?: (item: any) => FilterPrimitive
   ): FilterExpression | null {
      return buildPrimaryKeyFilterExpression(primaryKey, trigger.existingItems, getExistingPrimaryKey);
   }

   initialize(
      formField: MatFormField,
      trigger: LcsSingleSelectDirective<TItem>,
      element: HTMLInputElement,
      actions: EagerSelectActions<TItem, TApiResponseItem>,
      selectors: EagerSelectSelectors<TItem, any>,
      getAdditionalFields: () => string[] | null | undefined,
      getUrlOverride: () => string | undefined,
      buildSearchFilter: () => FilterExpression | null,
      defaultFilters: string[] | undefined
      // TODO: ordering options
   ) {
      const load = () => {
         this.store.dispatch(
            actions.load({
               additionalFields: getAdditionalFields(),
               filterOverrides: defaultFilters,
               urlOverride: getUrlOverride(),
            })
         );
      };
      const callState = this.store.pipe(select(selectors.selectCollectionCallState));
      const search = (searchTerm: string | null | undefined) => {
         return this.store.dispatch(actions.search({ filter: buildSearchFilter(), searchTerm }));
      };
      const searchReset = () => {
         if (!element.disabled) {
            return this.store.dispatch(actions.searchReset());
         }
      };
      return this.eagerSelectStatusService.initialize(
         formField,
         trigger,
         element,
         callState,
         load,
         search,
         searchReset
      );
   }
}
